<template>
    
    <div class="main">
        <c-panel>
            <form-curso-complementar :paramId="$route.params.id" v-on:onSubmitCursoComplementar="onSubmitCursoComplementar"></form-curso-complementar>
        </c-panel>
    </div>
    
</template>
<script>

import formCursoComplementar from "./form"

export default {
    methods:{

        onSubmitCursoComplementar(){

            this.$router.push('/admin/curso-complementar');  
        }
    },
    components:{ formCursoComplementar }
}
</script>
